module.exports = "<h1>Page Not Found</h1>\r\n<div class=\"error\">\r\n    <p>The page you requested cannot be displayed.</p>\r\n</div>\r\n<h1><a class=\"label label-default back-button\" (click)=\"goBack()\"><span aria-hidden=\"true\">&larr;</span> Back</a></h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/error-handling/not-found/not-found.component.html
// module id = ./src/app/shared/error-handling/not-found/not-found.component.html
// module chunks = main